import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {ServerMethods} from '../../services/proto/core/constants';
import {getAdditionalProps} from '../../services/proto/core/loginProps';
import {callServer, Options} from '../../services/proto/core/server';

export const GetMessageColumns = async (FormNamePath: string[], options?: Partial<Options>) => {
    return callServer(
        wcfclient.GetMessageColumns,
        new priority.netitems.nrule.GetMessageColumnsRq({
            Properties: getAdditionalProps(),
            FormNamePath: FormNamePath
        }),
        ServerMethods.GetMessageColumnsRq,
        options
    );
};

export const uploadImage = async (
    fileName: string,
    data: Uint8Array
): Promise<priority.netitems.ngen.UploadImageRs> => {
    return callServer(
        wcfclient.UploadImage,
        new priority.netitems.ngen.UploadImageRq({
            Properties: getAdditionalProps(),
            Filename: fileName,
            Data: data
        }),
        ServerMethods.UploadImageRq
    );
};
